import React, { useState } from 'react'
import styles from 'modules/PartnersProgram/subcomponents/Table/Table.module.scss'
import { Button, Col, Grid, Icon, List, Switcher, Typography } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import { useTableConfig } from 'modules/PartnersProgram/subcomponents/Table/hooks/useTableConfig'
import EmptyResults from 'components/EmptyResults'
import clsx from 'clsx'
import Dot from 'components/Dot'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import PropTypes from 'prop-types'

const Table = ({ data = [], replenishByPartners, setReplenishByPartners }) => {
  const { t } = useTranslation()
  const [collapsed, setCollapsed] = useState(true)
  const { tableState, tableConfig } = useTableConfig(data, collapsed)
  const breakpoint = useBreakpoint()
  return (
    <div className={styles['table']}>
      <Grid
        gap={!breakpoint.lg ? 16 : 32}
        direction={!breakpoint.lg ? 'column' : 'row'}
        wrap={false}
        className={'margin-bottom-24'}
      >
        <Col>
          <Typography
            component={'h4'}
            className={'margin-bottom-16'}
            color={'Label-Primary'}
            variant={'Header-30'}
          >
            {t('partners_program::sub_heading')}
          </Typography>
          <Typography color={'Label-Primary'} variant={'Body-15'}>
            {t('partners_program::sub_summary')}
          </Typography>
        </Col>
        <Grid
          direction={'row'}
          gap={16}
          wrap={false}
          alignItems={'center'}
          justifyContent={!breakpoint.lg ? 'start' : 'end'}
        >
          <Col>
            <Switcher
              checked={replenishByPartners}
              onChange={() => setReplenishByPartners((state) => !state)}
            />
          </Col>
          <Typography variant={!breakpoint.lg ? 'Header-20' : 'Header-25'}>
            {t('partners_program::replenishment_via_partners')}
          </Typography>
        </Grid>
      </Grid>
      <div className={clsx(styles['table__wrapper-list'], 'margin-bottom-16')}>
        <List
          table={tableState}
          config={tableConfig}
          EmptyComponent={() => (
            <EmptyResults
              header={t('media_planner::table.empty_results.heading')}
              text={t('media_planner::table.empty_results.text', {
                buttonLabel: t('media_planner::form.submit.label'),
              })}
              icon={<Icon name={'task'} color={'Interface-Onsurface'} width={64} />}
            />
          )}
        />
      </div>

      <Grid justifyContent={'center'} className={'margin-bottom-24'}>
        <Button
          variant={'secondary'}
          link
          endIcon={<Icon name={collapsed ? 'arrow-down' : 'arrow-up'} color={'Label-Fifth'} />}
          onClick={() => setCollapsed((collapsed) => !collapsed)}
        >
          {t(`partners_program::${collapsed ? 'expand_table' : 'collapse_table'}`)}
        </Button>
      </Grid>

      <Grid
        wrap={false}
        alignItems={'center'}
        justifyContent={'center'}
        gap={40}
        fluid={false}
        className={'margin-bottom-16'}
      >
        <Grid wrap={false} alignItems={'center'} justifyContent={'start'}>
          <Dot touched />
          <Typography variant={'Body-15'} color={'Label-Secondary'}>
            {t('partners_program::reward')}
          </Typography>
        </Grid>
        <Grid wrap={false} alignItems={'center'} justifyContent={'center'}>
          <Dot error />
          <Typography variant={'Body-15'} color={'Label-Secondary'}>
            {t('partners_program::commission')}
          </Typography>
        </Grid>
      </Grid>

      <Grid>
        <Typography variant={'Body-15'} color={'Label-Secondary'}>
          {t('partners_program::note')}
        </Typography>
      </Grid>
    </div>
  )
}
export default Table

Table.propTypes = {
  data: PropTypes.array,
  replenishByPartners: PropTypes.bool,
  setReplenishByPartners: PropTypes.func,
}
